import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideFinzzleAuth } from '@finzzle/auth';
import { OuiSnackbarModule } from 'omnium-ui/snackbar';
import { AppComponent } from './app/app.component';
import { appRoutePaths } from './app/app.paths';
import { authInterceptor } from './app/core/auth/auth.interceptor';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes),
    provideAnimations(),
    // withInterceptorsFromDi() est requis par le MsalInterceptor de @finzzle/auth.
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withInterceptors([authInterceptor])),
    provideFinzzleAuth({
      clientId: environment.auth.clientId,
      authority: environment.auth.authority,
      knownAuthorities: environment.auth.knownAuthorities,
      loginScopes: [environment.auth.apiScope, 'openid', 'profile'],
      permissionsMap: { [environment.apiBaseUrl.replace(/\/$/, '')]: [environment.auth.apiScope] },
      loginFailedRoute: appRoutePaths.auth
    }),
    importProvidersFrom(OuiSnackbarModule)
  ]
})
  .catch(error => console.error(error));
